import { page } from "@randajan/jet-react/base/page";
import { usePop } from "@randajan/jet-react/dom/modal";
import { useEffect } from "react";

import { Button } from "@mui/material";
import { Locale } from "../../assets/Locale";
import { Link } from "@randajan/jet-react/dom/link";

export const PagePopButton = (props) => {
    const { pop, icon, title, titleId } = props;
    const say = Locale.use();

    return (
        <Button
            className="BlimpMuiPanel-action"
            onClick={_ => pop.up()}
            startIcon={icon}
            variant="outlined"
        >
            {titleId ? say(titleId) : title}
        </Button>
    )
}

export const usePagePopFactory = (content, popOpt, {
    title, titleId, href, icon, pagePath, upValue = "up", upAllowed = true,
} = {}) => {

    if (pagePath) {
        popOpt.onDown = _ => page.remove(pagePath);
        popOpt.onUp = _ => page.set(pagePath, upValue);
    }

    const pop = usePop(popOpt);

    useEffect(_ => {
        if (!pop) { return; }
        pop.up = function (opt={}) {
            return pop.constructor.prototype.up.call(this, {...opt, children:content});
        }
    }, [content, pop]);

    useEffect(_ => {
        if (!upAllowed) { pop.down(); }
    }, [upAllowed]);

    useEffect(_ => {
        if (!pagePath) { return; }
        const onChange = _ => {
            const val = page.get(pagePath);
            if (val !== upValue) { pop.down(); return; }
            if (upAllowed) { pop.up(); return; }
            pop.down();
        };
        onChange();
        return page.watch(pagePath, onChange);
    }, [pagePath, upAllowed]);

    useEffect(_ => {
        pop.button = <PagePopButton pop={pop} icon={icon} title={title} titleId={titleId}/>;
    }, [pop, title, titleId, href, icon]);

    return pop;
}